<template>
    <v-dialog persistent v-model="get_MainMessageDialog.dialog" :width="get_MainMessageDialog.with" justify-center>
      <v-card width="auto" tile>
        <v-card-title class="text-h5 text-center blue-grey lighten-3 ">
          <v-icon v-if="get_MainMessageDialog.icon" large left color="primary">{{get_MainMessageDialog.icon}}</v-icon>
          <span class="text-h5 font-weight-bold text-uppercase">{{get_MainMessageDialog.title}}</span>
          <v-spacer/>
          <v-btn icon dark @click="HIDDEN_MAIN_MESSAGE_DIALOG()">
            <v-icon large color="primary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row dense>
            <v-col cols="12" v-if="get_MainMessageDialog.image" align="center">
              <v-img :src="require(`@/assets/images/message/${get_MainMessageDialog.image}.png`)" class="text-center" max-width="120" aspect-ratio="1.4" contain />
            </v-col>
            <v-col cols="12" class="text-center">
              <p class="subtitle-1 font-weight-bold black--text">{{ get_MainMessageDialog.description }}</p>
              <p v-if="get_MainMessageDialog.subdescription" class="subtitle-2">{{ get_MainMessageDialog.subdescription }}</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn class="mr-3" color="red darken-1" small depressed outlined @click="HIDDEN_MAIN_MESSAGE_DIALOG">{{get_MainMessageDialog.body.nameCancel}}</v-btn>
            <v-btn v-if="get_MainMessageDialog.body.showComfirm"
              class="mr-3" color="success darken-1" small depressed outlined @click="save">{{get_MainMessageDialog.body.nameComfirm}}</v-btn>
          </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: [],
  data: () => ({
    form: {
      status_finish: {}
    },
    object: {
      action: '',
      status: '',
      actual: ''
    }
  }),
  components: {},
  mounted () {},
  methods: {
    ...mapActions(['GetFormOptionServicesAction', 'postExecuteAction']),
    ...mapMutations(['HIDDEN_MAIN_MESSAGE_DIALOG', 'RESPONSE_DATA_DIALOG']),
    save () {
      this.RESPONSE_DATA_DIALOG({ name: this.get_MainMessageDialog.identity, model: this.get_MainMessageDialog.body.data })
      this.HIDDEN_MAIN_MESSAGE_DIALOG()
    }
  },
  computed: {
    ...mapGetters(['get_MainMessageDialog'])
  },
  watch: {}
}
</script>

<style>

</style>
